import { CLIENTS_URL } from 'constants'

import debounce from 'lodash/debounce'

import request from 'utils/request'
import { convertState } from 'utils/state'

import {
  CLIENTS_FETCHED,
  SEARCH_TERM_CHANGED,
  START_FETCHING,
  FILTER_CHANGED
} from './constants'


const clientsFetched = (clients, nextPage, prevPage, isNextPage = false) => {
  return {
    type: CLIENTS_FETCHED,
    prevPage,
    nextPage,
    clients,
    isNextPage
  }
}

const startFetching = () => {
  return {
    type: START_FETCHING
  }
}

const searchChanged = (searchTerm) => {
  return {
    type: SEARCH_TERM_CHANGED,
    searchTerm
  }
}

const filterChanged = (state, city) => {
  return {
    type: FILTER_CHANGED,
    state, city
  }
}

const fetchClients = (dispatch, query = null, state = null, city = null, nextPage = null) => {
  dispatch(startFetching())
  let url

  if ( nextPage ) {
    url = nextPage
  } else {
    url = `${CLIENTS_URL}?`
    const queryparams = {}
    if ( query ) { queryparams.q = query }
    if ( state ) { queryparams.s = state }
    if ( city ) { queryparams.c = city }

    Object.keys(queryparams).forEach((key) => url = `${url}${key}=${queryparams[key]}&`)
    url = url.substring(0, url.length - 1)
  }

  request(url)
  .then((res) => {
    dispatch(clientsFetched(res.clients, res.next, res.previous, !!nextPage))
  })
}

const _fetchClients = debounce(fetchClients, 500)


const retrieveFetchValues = (getState) => {
  const state = convertState(getState(), 'clients')
  const { searchTerm, filter } = state
  const params = [searchTerm, filter.state, filter.city]
  return params
}

export function fetchClientsOnSearch(searchTerm){
  return (dispatch, getState) => {
    // update searchTerm on state
    dispatch(searchChanged(searchTerm))
    const params = retrieveFetchValues(getState)
    // debounce fetchEvents to avoid calling API each time user types something
    return _fetchClients(dispatch, ...params)
  }
}

export function fetchOnFilter(stateId, cityId) {
  return (dispatch, getState) => {
    dispatch(filterChanged(stateId, cityId))
    const params = retrieveFetchValues(getState)
    return _fetchClients(dispatch, ...params) // debounced in case state/city changes to fast!
  }
}

export function fetchNextPage() {
  return (dispatch, getState) => {
    const state = convertState(getState(), 'clients')
    const { pagination } = state
    const nextPage = !!pagination.next && pagination.next.indexOf('http') >= 0 ? pagination.next.replace('http', 'https') : pagination.next
    return fetchClients(dispatch, null, null, null, nextPage)
  }
}

export const initFetch = () => {
  return (dispatch, getState) => {
    return fetchClients(dispatch)
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Clients/actions.js